// initGsap.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { lenis } from "./lenis";
import { updateHeaderHeight } from './setHeaderHeight';

export const initGsap = () => {
  gsap.registerPlugin(ScrollTrigger);

  // LenisとGSAPを同期（GSAPのrafのみ使用）
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });

  // 初期化
  ScrollTrigger.refresh();

  // ロゴの大きさを変化 & ナビの切り替え
  ScrollTrigger.create({
    trigger: ".kv",
    start: "bottom top+=10",
    onEnter: () => {
      document.querySelector(".header-logo")?.classList.add("on");
      document.querySelector(".header .inner")?.classList.add("on");
    },
    onLeaveBack: () => {
      document.querySelector(".header-logo")?.classList.remove("on");
      document.querySelector(".header .inner")?.classList.remove("on");
    },
  });

  gsap.to(".about-image img", {
    scrollTrigger: {
      trigger: ".about-image",
      start: "top bottom",
      end: "top top",
      scrub: 1.4,
    },
    scale: 1.4,
  });

  // 各セクションの背景色を変化
  const triggers = [
    { trigger: "section.sec.-about", className: "-about" },
    { trigger: "section.sec.-brand", className: "-brand" },
    { trigger: "section.sec.-shop", className: "-shop" },
    { trigger: ".footer", className: "-footer" },
  ];

  triggers.forEach(({ trigger, className }) => {
    ScrollTrigger.create({
      trigger,
      start: "top center",
      end: "bottom center",
      toggleClass: {
        targets: ".site-wrap",
        className: className,
      },
    });
  });

  // パララックス（縦）
  const imageParallax = () => {
    const items = gsap.utils.toArray(".js-image");
    items.forEach((item) => {
      const img = item.querySelector("img");
      if (!img) return;
      gsap.fromTo(
        img,
        { yPercent: 0 },
        {
          yPercent: -20,
          ease: "none",
          scrollTrigger: {
            trigger: item,
            start: "top center",
            end: "bottom top",
            scrub: 1,
          },
        }
      );
    });
  };

  imageParallax();
};
